module.exports = __webpack_public_path__ + "static/media/privacy.6ce64401.jpg";